import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import "./index.css";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

const SideNavBar = ({ routes }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileView, setIsMobileView] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  // handle sub menu
  const toggleSubMenu = (subMenu) => {
    setOpenSubMenu(openSubMenu === subMenu ? null : subMenu);
  };

  // Handle screen resizing to toggle sidebar automatically
  const handleResize = () => {
    const width = window.innerWidth;
    if (width < 1280) {
      setIsMobileView(true);
      setIsSidebarOpen(false);
    } else {
      setIsMobileView(false);
      setIsSidebarOpen(true);
    }
  };

  // Attach the resize event listener on mount
  useEffect(() => {
    handleResize(); // Check screen size on initial load
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isSidebarOpen && isMobileView) {
        const sidebar = document.getElementById("sidebar");
        if (sidebar && !sidebar.contains(event.target)) {
          setIsSidebarOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen, isMobileView]);


  // Toggle sidebar visibility
  const toggleSidebar = () => setIsSidebarOpen((prevState) => !prevState);


  // const renderRoutes = (routes) =>
  //   routes.map(({ type, name, icon, title, key, route, collapse }) => {
  //     if (type === "collapse") {
  //       if (collapse && collapse.length > 0) {
  //         return (
  //           <li key={key}>
  //             <div
  //               onClick={() => toggleSubMenu(key)}
  //               className="flex items-center justify-between px-4 py-2 rounded-lg cursor-pointer hover:bg-gray-200"
  //             >
  //               <div className="flex items-center gap-2">
  //                 <span className="text-xl">{icon}</span>
  //                 <span className="font-medium">{name}</span>
  //               </div>
  //               <Icon
  //                 icon={
  //                   openSubMenu === key ? "lsicon:down-filled" : "lsicon:right-filled"
  //                 }
  //               />
  //             </div>
  //             {openSubMenu === key && (
  //               <ul className="ml-6 mt-2 space-y-1">
  //                 {collapse.map(({ type, name, route, icon, key: subKey }, index) => {
  //                   const colors = ['text-blue-600', 'text-red-600', 'text-green-600', 'text-yellow-600'];
  //                   const iconColor = colors[index % colors.length];
  //                   return (
  //                     <li key={subKey}>
  //                       <a
  //                         href={route}
  //                         className="flex items-center px-4 py-2 rounded-lg hover:bg-gray-200"
  //                       >
  //                         <span className={`text-xs ${iconColor}`}>{icon}</span>
  //                         <span className="ml-2 text-sm font-medium">{name}</span>
  //                       </a>
  //                     </li>
  //                   );
  //                 })}
  //               </ul>
  //             )}
  //           </li>
  //         );
  //       } else {
  //         return (
  //           <li key={key}>
  //             <a
  //               href={route}
  //               className="flex items-center px-4 py-2 rounded-lg hover:bg-gray-200"
  //             >
  //               <span className="text-xl">{icon}</span>
  //               <span className="ml-2 font-medium">{name}</span>
  //             </a>
  //           </li>
  //         );
  //       }
  //     } else if (type === "title") {
  //       return (
  //         <li key={key} className="px-4 pt-4 font-semibold">
  //           {name}
  //         </li>
  //       );
  //     }
  //     return null;
  //   });

  const renderRoutes = (routes) =>
    routes.map(({ type, name, icon, title, key, route, collapse }) => {
      if (type === "collapse") {
        if (collapse && collapse.length > 0) {
          return (
            <li key={key}>
              <div
                onClick={() => toggleSubMenu(key)}
                className="flex items-center justify-between px-4 py-2 rounded-lg cursor-pointer hover:bg-gray-200"
              >
                <div className="flex items-center gap-2">
                  <span className="text-xl">{icon}</span>
                  <span className="font-medium">{name}</span>
                </div>
                <Icon
                  icon={
                    openSubMenu === key ? "lsicon:down-filled" : "lsicon:right-filled"
                  }
                />
              </div>
              {openSubMenu === key && (
                <ul className="ml-6 mt-2 space-y-1">
                  {collapse.map(({ type, name, route, icon, key: subKey }, index) => {
                    const colors = ['text-blue-600', 'text-red-600', 'text-green-600', 'text-yellow-600'];
                    const iconColor = colors[index % colors.length];
                    return (
                      <li key={subKey}>
                        <NavLink
                          to={route}
                          className={({ isActive }) =>
                            `flex items-center px-4 py-2 rounded-lg ${isActive ? "bg-[#487FFF] font-semibold text-white" : "hover:bg-gray-200"}`
                          }
                        >
                          <span className={`text-xs ${iconColor}`}>{icon}</span>
                          <span className="ml-2 text-sm font-medium">{name}</span>
                        </NavLink>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        } else {
          return (
            <li key={key}>
              <NavLink
                to={route}
                className={({ isActive }) =>
                  `flex items-center px-4 py-2 rounded-lg ${isActive ? "bg-[#487FFF] font-semibold text-white" : "hover:bg-gray-200"}`
                }
              >
                <span className="text-xl">{icon}</span>
                <span className="ml-2 font-medium">{name}</span>
              </NavLink>
            </li>
          );
        }
      } else if (type === "title") {
        return (
          <li key={key} className="px-4 pt-4 font-semibold">
            {name}
          </li>
        );
      }
      return null;
    });

  return (
    <>
      {/* Mobile toggle button */}
      {isMobileView && !isSidebarOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed top-2 left-4 z-50 p-2  text-gray-600 hover:text-gray-900 bg-[#F5F6FA] rounded-full"
        >
          <Icon icon="mdi:menu" width={24} />
        </button>
      )}

      {/* Sidebar */}
      {/* <div
        className={`h-screen fixed top-0 left-0 z-40 transform transition-transform duration-300 ${isSidebarOpen ? "translate-x-0 hover:overflow-y-scroll" : "-translate-x-full"
          } w-64`}
      > */}
      <div
        id="sidebar"
        className={`h-screen fixed top-0 left-0 z-40 transform transition-transform duration-300 bg-white
    ${isSidebarOpen ? "translate-x-0 hover:overflow-y-scroll" : "-translate-x-full"}
    w-64 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-gray-400/50 hover:scrollbar-thumb-gray-400/70`}
      >
        {/* Header */}
        <div className="p-2 flex items-center border-b border-r h-16 border-gray-100">
          <img src="/logoSeatsnaps.png" alt="Logo" className="h-12" />
        </div>

        {/* Navigation */}
        <nav className="flex-1">
          <ul className="space-y-1 p-2">
            {renderRoutes(routes)}
          </ul>
        </nav>
      </div>
    </>
  );
};

SideNavBar.propTypes = {
  // color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  // brand: PropTypes.string,
  // brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SideNavBar;
